import React from 'react';
import i18n from 'i18next';
import Button from '@/Components/Button';
import Authenticated from '@/Layouts/Authenticated';
import ValidationErrors from '@/Components/ValidationErrors';
import {Head, Link, useForm, usePage} from '@inertiajs/inertia-react';
import {OrganizationLogoManagement} from "@/Components/Manage/OrganizationLogoManagement";


export default function UploadLogo() {
    const {data, setData, post, processing, errors, reset} = useForm({
        key: "",
        uuid: "",
        name: "",
        extension: "",
        url: "",
        signup_flow: true,
    });

    const assetDomain = usePage().props.assetDomain;

    const submit = (e) => {
        e.preventDefault();

        post(route('manage.organization.logo.store'));
    };

    return (
        <Authenticated className="extra-spacing" hideTopBar={true}>
            <Head title="Upload Logo"/>
            <div className="outside-logo"></div>
            <div className="upload-logo">
                <ValidationErrors errors={errors}/>
                <form onSubmit={submit}>
                    <div className="title" data-testid="upload_logo-div-title">{i18n.t("upload-logo.upload-logo")}</div>
                    <OrganizationLogoManagement
                        organizationName={usePage().props.auth.current_organization.name}
                        logoUrl={data.url}
                        onFileUploaded={file => {
                            setData({...file, url: `${assetDomain}/${file.key}`, signup_flow: true})
                        }}
                        deleteLogo={false}
                        onDelete={() => {
                            reset('url')
                        }}
                    ></OrganizationLogoManagement>
                    <div className="">
                        <Button className="w-100 btn btn-primary" processing={processing || !data.url} dataTestid="upload_logo-button-done">
                            <span>{i18n.t("upload-logo.done")}</span>
                        </Button>
                    </div>
                    <Link as="button"
                          method="POST"
                          className="w-100 btn btn-outline-secondary"
                          href={route('organization.upload-logo.skip')}
                          data-testid="upload_logo-link-skip_logo"
                    >
                        {i18n.t("upload-logo.skip-logo")}
                    </Link>
                </form>
            </div>
            <div className="step">
                <Link href={route('organization.add-denomination.show')} className="no-link"
                      datatestid="upload_logo-link-add_denomination">
                    <i className="fal fa-long-arrow-left"></i>
                </Link>
                <span>{i18n.t("upload-logo.step")} 5 {i18n.t("upload-logo.of")} 5</span>
            </div>
        </Authenticated>
    );
}
